import FilterChipMixin from './mixin.js';

const selection_filter_chip_comp = {
  mixins: [FilterChipMixin],

  computed: {
    text_value: function() {
      return _.pluck(this.filter.value, 'value').join(', ');
    }
  }
};

export {
  selection_filter_chip_comp as RadioButtonFilterChip,
  selection_filter_chip_comp as CheckBoxFilterChip,
  selection_filter_chip_comp as YAW__AssignmentStatusFilterChip
};
